export const salesQueryBuilder = (metrics, dimension) => {
    const dimensionStr = `dimensions { 
        ${dimension} 
    }`
    const dimensionQuery = dimension ? dimensionStr: ``
    return `
        sales {
            edges {
                node {
                    ${dimensionQuery}
                    metrics {
                        ${metrics.join(`
                        `)}
                    }
                }
            }
        }
    `
}